export type Mood = { name: string; icon: string };

export type AttachmentKind = 'image' | 'text' | 'markdown' | 'pdf' | 'download' | 'archive';

export type Attachment = {
  id: string;
  url: string;
  downloadUrl: string;
  name: string;
  storedName: string;
  mimeType: string;
  storedMimeType: string;
  kind: AttachmentKind;
  originalSize: number;
  size: number;
  sortOrder: number;
  available: boolean;
};

export type Diary = {
  id: string;
  title: string;
  body: string;
  mood: Mood | null;
  starred: boolean;
  status: 'saved';
  createdAt: string;
  updatedAt: string;
  version: number;
  storageBytes: number;
  attachments: Attachment[];
};

export type Draft = Omit<Diary, 'status'> & { status: 'draft' };

export type DiaryInput = Pick<Diary, 'id' | 'title' | 'body' | 'mood' | 'starred' | 'createdAt'> & {
  version?: number;
};

export type StorageItem = {
  attachmentId: string | null;
  objectKey: string;
  name: string;
  storedName: string;
  diaryId: string | null;
  diaryTitle: string | null;
  kind: AttachmentKind;
  size: number;
  status: 'normal' | 'missing' | 'orphan';
  createdAt: string;
};

export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) {
    super(message);
  }
}
